import React from "react";
import { ICurrentUser } from "../types/users";

const LoggedInUserContext = React.createContext<ICurrentUser>({} as ICurrentUser);
export const Consumer = LoggedInUserContext.Consumer;

export default LoggedInUserContext;
